import { render, staticRenderFns } from "./TheValueChartBreakdownModal.vue?vue&type=template&id=322a58e8&"
import script from "./TheValueChartBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./TheValueChartBreakdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports